var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.storeLoading,
          expression: "storeLoading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c("StepNav", {
        attrs: { step: _vm.step, mode: _vm.mode },
        on: { jump: _vm.jumpStep },
      }),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { attrs: { "no-title": "" } },
        [
          _vm.step === 1
            ? _c("StoreInfoStep", {
                attrs: {
                  info: _vm.storeBaseInfo,
                  form: _vm.form,
                  rules: _vm.rules,
                  "is-bailian-flag": _vm.isBailianFlag,
                  "opt-config": _vm.optConfig,
                  "is-qzkh": _vm.isQzkh,
                  mode: _vm.mode,
                },
                on: {
                  draft: _vm.onSaveDraft,
                  draftAndGo: function ($event) {
                    return _vm.onSaveDraftAndGo(2)
                  },
                  next: function ($event) {
                    return _vm.jumpStep(2)
                  },
                },
              })
            : _vm.step === 2
            ? _c("SalesStep", {
                attrs: {
                  info: _vm.storeBaseInfo,
                  form: _vm.form,
                  rules: _vm.rules,
                  "is-bailian-flag": _vm.isBailianFlag,
                  "opt-config": _vm.optConfig,
                  mode: _vm.mode,
                },
                on: {
                  draft: _vm.onSaveDraft,
                  draftAndGo: function ($event) {
                    return _vm.onSaveDraftAndGo(3)
                  },
                  next: function ($event) {
                    return _vm.jumpStep(3)
                  },
                },
              })
            : _vm.step === 3
            ? _c("TPPRecordsStep", {
                attrs: { tppinfo: _vm.tppinfo, mode: _vm.mode },
                on: {
                  draft: _vm.onSaveDraft,
                  next: function ($event) {
                    return _vm.jumpStep(4)
                  },
                },
              })
            : _vm.step === 4
            ? _c("SalesRecordStep", {
                attrs: {
                  "pt-info": _vm.ptInfo,
                  "opt-config": _vm.optConfig,
                  mode: _vm.mode,
                },
                on: {
                  draft: _vm.onSaveDraft,
                  next: function ($event) {
                    return _vm.jumpStep(5)
                  },
                },
              })
            : _vm.step === 5
            ? _c("TrainingRecordStep", {
                attrs: {
                  form: _vm.form,
                  rules: _vm.rules,
                  "opt-config": _vm.optConfig,
                  mode: _vm.mode,
                },
                on: {
                  draft: _vm.onSaveDraft,
                  draftAndGo: function ($event) {
                    return _vm.onSaveDraftAndGo(6)
                  },
                  next: function ($event) {
                    return _vm.jumpStep(6)
                  },
                },
              })
            : _vm.step === 6
            ? _c("VisitorRecordStep", {
                attrs: {
                  "pt-info": _vm.ptInfo,
                  "feedback-check-list": _vm.feedbackCheckList,
                  form: _vm.form,
                  rules: _vm.rules,
                  "is-bailian-flag": _vm.isBailianFlag,
                  "opt-config": _vm.optConfig,
                  mode: _vm.mode,
                },
                on: { draft: _vm.onSaveDraft, save: _vm.onEnsureDialog },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }